import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const purchases = [{
  name: 'Andrés R.',
  location: 'Buenos Aires, Argentina'
}, {
  name: 'María C.',
  location: 'CDMX, México'
}, {
  name: 'Juan P.',
  location: 'Bogotá, Colombia'
}, {
  name: 'Fernando L.',
  location: 'Santiago, Chile'
}, {
  name: 'Valeria T.',
  location: 'Lima, Perú'
}, {
  name: 'Carlos R.',
  location: 'Montevideo, Uruguay'
}, {
  name: 'Sofía M.',
  location: 'Quito, Ecuador'
}, {
  name: 'Daniel G.',
  location: 'Caracas, Venezuela'
}, {
  name: 'Laura P.',
  location: 'Ciudad de Guatemala, Guatemala'
}, {
  name: 'Pablo D.',
  location: 'San José, Costa Rica'
}, {
  name: 'Camila V.',
  location: 'Asunción, Paraguay'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextPopup();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextPopup = () => {
    const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
    setCurrentPurchase(randomPurchase);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextDelay = Math.floor(Math.random() * 10000) + 10000;
      setTimeout(showNextPopup, nextDelay);
    }, 4000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 max-w-[250px] md:max-w-[270px]" style={{
    animation: 'popIn 0.6s ease-out forwards'
  }} data-id="element-245">
      <div className="bg-gradient-to-br from-emerald-500 to-green-700 rounded-xl border-4 border-yellow-300 p-2.5 flex items-start gap-2.5 relative overflow-hidden" style={{
      animation: 'borderPulse 2s ease-in-out infinite'
    }} data-id="element-246">
        <div className="bg-white p-1 rounded-full shrink-0 mt-0.5 shadow-md" data-id="element-247">
          <CheckCircle className="w-3.5 h-3.5 text-emerald-600" data-id="element-248" />
        </div>
        <div className="flex-grow min-w-0" data-id="element-249">
          <p className="text-[10px] md:text-[11px] text-white font-bold leading-tight mb-1" data-id="element-250">
            <span className="font-black text-yellow-200 uppercase" data-id="element-251">
              {currentPurchase.name}
            </span>{' '}
            de <span className="font-black" data-id="element-252">{currentPurchase.location}</span>{' '}
            acaba de comprar el Kit 💳
          </p>
          <p className="text-[9px] text-yellow-100/90 font-black tracking-wider uppercase" data-id="element-253">
            Hace unos minutos
          </p>
        </div>
      </div>
    </div>;
}